__turbopack_context__.v({
  "radioWrap": "YearPicker-module-scss-module__VpnPoa__radioWrap",
  "visuallyHidden": "YearPicker-module-scss-module__VpnPoa__visuallyHidden",
  "yearPicker": "YearPicker-module-scss-module__VpnPoa__yearPicker",
});
